/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accRenameAction', function(){
            return {
                scope: {
                    node: '='
                },
                restrict: 'E',
                template: '<a href id="rename-action" ng-click="click()">\
                                <span class="wrapper-icon"><i class="icon-acc-rename"></i></span>\
                                <span class="wrapper-text">{{ "Rename" | translate }}</span>\
                           </a>',
                replace: true,
                controller: ['$scope', function($scope) {

                    $scope.$on('$destroy', function() {
                        $scope.node['renaming'] = false;
                    });

                    $scope.click = function(){
                        $scope.node['renaming'] = true;
                    }
                }]
            }
        });